import sanity from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';
import BlockContent from 'sanity-blocks-vue-component';
import envs, { isProduction } from './envs';

export { BlockContent };

export const sanityClient = sanity({
  projectId: envs.sanity.projectId,
  dataset: envs.sanity.dataset,

  // useCdn == true gives fast, cheap responses using a globally distributed cache.
  // Set this to false if your application require the freshest possible
  // data always (potentially slightly slower and a bit more expensive).
  useCdn: isProduction(),
});

const builder = imageUrlBuilder(sanityClient);

export function urlFor(image: object) {
  return builder.image(image);
}
